export class CustomerUpdateResponse {
    ApplicationId: String;
    OnBaseId: String;

    constructor() {
        this.ApplicationId = "";
        this.OnBaseId = "";
    }
}